import React from "react";
import { Link } from "react-router-dom";
import productsData from "../data/products.json";

import "../styles/Products.css";

const Products = () => {
    // pegar só alguns para destaque
    const featured = productsData.slice(0, 4);

    const getImage = (file) => require(`../assets/${file}`);

    return (
        <section id="produtos" className="products">
            <div className="products-container">
                <div className="products-header">
                    <h2>Nossos Produtos</h2>
                    <p>
                        Cada categoria de produtos é desenvolvida com foco na qualidade,
                        durabilidade e design sofisticado, atendendo às necessidades mais
                        exigentes do mercado premium.
                    </p>
                </div>

                <div className="products-grid">
                    {featured.map((p) => (
                        <div key={p.id} className="product-card">
                            <div className="product-content">
                                <div className="product-text">
                                    <h3>{p.title}</h3>
                                    <p>{p.description}</p>
                                    <ul>
                                        {p.specs && p.specs.slice(0, 3).map((s, i) => (
                                            <li key={i}>{s}</li>
                                        ))}
                                    </ul>
                                    <Link to={`/produto/${p.id}`} className="btn-outline">
                                        Saiba Mais →
                                    </Link>
                                </div>
                                <div className="product-image">
                                    <img src={getImage(p.images[0])} alt={p.title} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Products;
